import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"font-family":"'sans-serif'"}
}

import { computed } from 'vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SiteText',
  props: {
    field: {},
    editable: { type: Boolean },
    tag: {},
    encode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isEditable = computed(() => props.editable !== false && Boolean(props.field?.editable));
const hasValue = computed(() => {
  const v = props.field?.value;
  return v !== undefined && v !== '';
});
const segments = computed<string[]>(() => {
  const value = props.field?.value;
  if (!value || typeof value !== 'string') return [];
  return value.split('&');
});

return (_ctx: any,_cache: any) => {
  return (isEditable.value)
    ? (_openBlock(), _createBlock(_unref(Text), {
        key: 0,
        field: __props.field,
        editable: true,
        tag: __props.tag
      }, null, 8, ["field", "tag"]))
    : (hasValue.value)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag || 'span'), { key: 1 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, (seg, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                (i > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, "&"))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(seg), 1)
              ], 64))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
}
}

})